import type { ReactNode } from "react";
import { useMsal } from "@azure/msal-react";
import { BrandMark } from "./BrandMark";

interface Props {
  title: string;
  envLabel?: string;
  children?: ReactNode;
}

export function TopBar({ title, envLabel, children }: Props) {
  const { instance } = useMsal();
  const account = instance.getActiveAccount() ?? instance.getAllAccounts()[0];

  return (
    <header className="flex items-center gap-6 py-3.5 px-7 bg-rs-black border-b border-rs-jet sticky top-0 z-20 flex-wrap">
      <a className="flex items-center gap-[11px] no-underline" href="/" title="Home">
        <BrandMark />
        <span className="text-xl font-semibold text-white tracking-[-0.015em] leading-none whitespace-nowrap">ResinSmart</span>
      </a>
      <a
        className="flex items-center justify-center bg-transparent border-none text-rs-light-gray p-[7px] rounded-md no-underline flex-none hover:text-rs-green hover:bg-rs-jet"
        href="/"
        title="Home"
        aria-label="Home"
      >
        <span className="material-symbols-sharp text-[22px]">home</span>
      </a>
      <span className="w-px h-[26px] bg-rs-jet-light" aria-hidden="true"></span>
      <div>
        <h1 className="text-[17px]">{title}</h1>
      </div>
      {envLabel && (
        <span className="text-[11px] text-rs-light-gray border border-rs-jet-light py-[3px] px-[9px] rounded-[3px]">
          {envLabel}
        </span>
      )}

      <div className="flex gap-[22px] ml-auto items-center">
        {children}
        {account && (
          <button
            className="flex items-center justify-center bg-transparent border-none text-rs-light-gray p-[7px] rounded-md flex-none hover:text-rs-green hover:bg-rs-jet"
            onClick={() => instance.logoutRedirect({ postLogoutRedirectUri: `${window.location.origin}/` })}
            title={`Sign out (${account.username})`}
            aria-label="Sign out"
          >
            <span className="material-symbols-sharp text-[22px]">logout</span>
          </button>
        )}
      </div>
    </header>
  );
}
